<template>
  <div class="relative w-full select-none mt-8 mb-8">

    <!-- Steg -->
    <ol class="relative z-1 flex justify-between items-start gap-4 md:gap-6">

      <li v-for="n in total" :key="n" class="flex flex-col items-center text-center relative flex-1">
        <div
          class="absolute left-[calc(50%+15px)] md:left-[calc(50%+20px)] top-[15px] md:top-[19px] h-[1px] border transition-all w-[calc(100%-14px)] md:w-[calc(100%-15px)]"
          :class="n < clampedStep
            ? 'border-solid border-[#47851E]'
            : n === clampedStep
              ? 'border-dashed border-[#9D9D9C]'
              : 'border-dashed border-[#9D9D9C]'"
          role="progressbar"
          aria-valuemin="1"
          aria-valuemax="5"
          :aria-valuenow="clampedStep"
          v-if="n!=total"
        >
        </div>

        <div
          class="max-w-[100px] w-8 h-8 md:w-10 md:h-10 rounded-full grid place-items-center border border-solid text-button-small font-normal transition-colors"
          :class="n < clampedStep || activeStep == 6
            ? 'bg-[#E5EEC8] border-[#47851E]'
            : n === clampedStep
              ? 'bg-blue-500 border-blue-500'
              : 'bg-white text-[#9D9D9C] border-[#9D9D9C]'">
          {{ n }}
        </div>
        <span class="text-caption mt-1" v-html="this.texts[n-1]"></span>
      </li>
    </ol>
  </div>
</template>



<script>
export default {
  name: 'stepwizzard',
  props: {
    activeStep: Number,
  },
  data() {
    return {
      total: 5,
      texts: ['Person&shy;nummer', 'Kontakt&shy;uppgifter', 'Bekräfta e&#8209;post', 'Välj inloggning', 'Identifiera med BankID']
    };
  },
  computed: {
    clampedStep() {
      return Math.min(Math.max(1, Math.round(this.activeStep)), this.total)
    }
  },

};
</script>
